class AutoApplyDiscount {
  constructor() {
    this.init();
  }

  init() {
    this.interceptCheckoutButtons();
    
    document.addEventListener('cart:updated', () => {
      setTimeout(() => {
        this.interceptCheckoutButtons();
        this.syncCartDiscountAttribute();
      }, 500);
    });
  }

  interceptCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll(
      'button[name="checkout"], ' +
      '#CartDrawer-Checkout, ' +
      'a[href*="/checkout"], ' +
      '[href="/checkout"], ' +
      '.cart__checkout-button, ' +
      'button[form*="cart"], ' +
      'button[form*="Cart"]'
    );

    checkoutButtons.forEach(button => {
      if (button.dataset.discountIntercepted) return;
      button.dataset.discountIntercepted = 'true';
      
      button.addEventListener('click', (e) => {
        this.handleCheckoutClick(e, button);
      }, true);
    });
  }

  async handleCheckoutClick(event, button) {
    try {
      const discountCode = await this.getDiscountCodeFromCart();
      
      if (discountCode && discountCode.trim() !== '') {
        event.preventDefault();
        event.stopPropagation();
        
        window.location.href = `/discount/${discountCode.trim()}?redirect=/checkout`;
        return false;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async getDiscountCodeFromCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      if (!cart.items || cart.items.length === 0) {
        return null;
      }

      for (const item of cart.items) {
        if (item.properties && item.properties._discount_code) {
          return item.properties._discount_code;
        }
      }
      
      const productInfo = document.querySelector('product-info[data-discount-code]');
      if (productInfo) {
        return productInfo.dataset.discountCode;
      }
      
      const cartDrawer = document.querySelector('[data-discount-code]');
      if (cartDrawer) {
        return cartDrawer.dataset.discountCode;
      }
      
      return null;
    } catch (error) {
      return null;
    }
  }

  async syncCartDiscountAttribute() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const code = await this.getDiscountCodeFromCart();
      if (!code || !cart) return;
      const current = cart.attributes && cart.attributes.discount_code ? String(cart.attributes.discount_code) : '';
      if (current && current.toUpperCase() === String(code).toUpperCase()) return;

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { discount_code: code } })
      });
    } catch (error) {
      console.error(error);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new AutoApplyDiscount();
});

window.AutoApplyDiscount = AutoApplyDiscount;
